import { Instance } from 'mobx-state-tree';
import model from './model';
import actions from './actions';

const Version = model.actions(actions);

export interface IVersionStore extends Instance<typeof Version> {}

export default Version;
